import { render, staticRenderFns } from "./NavAppointmentHolder.vue?vue&type=template&id=48233ecc"
import script from "./NavAppointmentHolder.vue?vue&type=script&lang=js"
export * from "./NavAppointmentHolder.vue?vue&type=script&lang=js"
import style0 from "./NavAppointmentHolder.vue?vue&type=style&index=0&id=48233ecc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports